import React from 'react';
import {
  HashRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import useQueryString from 'hooks/useQueryString';

import Header from './Header';
import Footer from './Footer';
import Viz from './Viz';
import About from './About';

const App = () => {
  // const base = window.location.hostname === 'localhost' ? '/' : '/global-games-2021';
  const [lang, setLang] = useQueryString('lang');

  const handleLangChange = (_lang) => {
    setLang(_lang);
  };

  return (
    <>
      <Router>
        <Header lang={lang} handleLangChange={handleLangChange} />
        <Switch>
          <Route
            exact
            path="/"
            render={(props) => (
              <Viz {...props} lang={lang} />
            )}
          />
          <Route
            exact
            path="/:about"
            render={(props) => (
              <About {...props} lang={lang} />
            )}
          />
        </Switch>
        <Footer lang={lang} />
      </Router>
    </>
  );
};

export default App;
